import axios from 'axios';

import { parseLiaDetailResponseForFE, parseSoftDeleteLiaForBE, parseUpdateLiaForBE } from './lia.parsers';
import type { LiaApi, LiaDetailResponseDTO, SoftDeleteLiaInput } from './lia.types';

const buildLiaEndpoint = (organizationId: number, purposeId: number) =>
  `api/v1/organizations/${organizationId}/processing-purposes/${purposeId}/lia/`;

const buildSoftDeleteEndpoint = (organizationId: number, purposeId: number) => `${buildLiaEndpoint(organizationId, purposeId)}soft-delete/`;

export const liaApi: LiaApi = {
  getActive: async (organizationId, purposeId) => {
    const { data } = await axios.get<LiaDetailResponseDTO>(buildLiaEndpoint(organizationId, purposeId));
    return { data: parseLiaDetailResponseForFE(data) };
  },
  create: async (organizationId, purposeId) => {
    const { data } = await axios.post<LiaDetailResponseDTO>(buildLiaEndpoint(organizationId, purposeId));
    return { data: parseLiaDetailResponseForFE(data) };
  },
  update: async (organizationId, purposeId, payload) => {
    const { data } = await axios.patch<LiaDetailResponseDTO>(buildLiaEndpoint(organizationId, purposeId), parseUpdateLiaForBE(payload));
    return { data: parseLiaDetailResponseForFE(data) };
  },
  softDelete: async (organizationId, purposeId, payload: SoftDeleteLiaInput) => {
    const { data } = await axios.post<LiaDetailResponseDTO>(
      buildSoftDeleteEndpoint(organizationId, purposeId),
      parseSoftDeleteLiaForBE(payload),
    );
    return { data: parseLiaDetailResponseForFE(data) };
  },
};

export default liaApi;
